import { styled } from '@mui/material/styles';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { PopperMenu } from '@components/Popper';
import Tooltip from '@components/Tooltip';
import { Typography } from '@components/Typography';

export const StyledMenuItem = styled(MenuItem)({
    '&.Mui-disabled': {
        pointerEvents: 'auto',
    },
    '& svg path': {
        fill: 'var(--text-secondary)',
    },
});

const MoreMenu = ({ className, id, menu, handleOpenEl, handleCloseEl, anchor }) => {
    return (
        <>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                <IconButton onClick={e => handleOpenEl(e, id)} className={className}>
                    <MoreVertIcon viewBox="0 0 22 22" />
                </IconButton>
            </div>
            {anchor.id === id ? (
                <ClickAwayListener onClickAway={handleCloseEl}>
                    <PopperMenu anchorEl={anchor.el} open={!!anchor.el}>
                        {menu.map(item => {
                            return item.tooltip ? (
                                <Tooltip key={item.id} title={item.tooltip} placement="top">
                                    <StyledMenuItem
                                        key={item.id}
                                        sx={{ gap: '8px', minWidth: '150px' }}
                                        disabled={item.disabled}
                                        onClick={item.disabled ? null : item.onClick}
                                    >
                                        {item.icon}
                                        <Typography variant="body2">{item.title}</Typography>
                                    </StyledMenuItem>
                                </Tooltip>
                            ) : (
                                <StyledMenuItem
                                    key={item.id}
                                    sx={{ gap: '8px', minWidth: '150px' }}
                                    disabled={item.disabled}
                                    onClick={item.disabled ? null : item.onClick}
                                >
                                    {item.icon}
                                    <Typography variant="body2">{item.title}</Typography>
                                </StyledMenuItem>
                            );
                        })}
                    </PopperMenu>
                </ClickAwayListener>
            ) : null}
        </>
    );
};

export default MoreMenu;
